import { AuthService, HttpErrorReporterService } from '@abp/ng.core';
import { SETTING_MANAGEMENT_HAS_SETTING } from '@abp/ng.setting-management/config';
import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { tap } from 'rxjs/operators';

// ABP'nin setting-management rotasi requiredPolicy tasimadigi icin permissionGuard her zaman izin veriyor.
// Menu gorunurlugu ile ayni kurali kullanip yetkili sekmesi olmayan kullaniciya 403 gosteriyoruz.
export const settingManagementGuard: CanActivateFn = () => {
  const hasSetting$ = inject(SETTING_MANAGEMENT_HAS_SETTING);
  const authService = inject(AuthService);
  const httpErrorReporter = inject(HttpErrorReporterService);

  return hasSetting$.pipe(
    tap(hasSetting => {
      if (!hasSetting && authService.isAuthenticated) {
        httpErrorReporter.reportError({ status: 403 } as HttpErrorResponse);
      }
    }),
  );
};
